/**
 * test vad gör ni
 */

acf.addAction('ready', function () {
  inputHidden();
  repeaterLinker();
  move_ws_1_step_1_result();
});

acf.addAction('af/form/page_changed', function () {
  stepsLoader();
});

acf.addAction('append', function ($el) {
  addIndexToRepeaterRow($el);
});

/**
 *
 */
function addIndexToRepeaterRow($el) {
  if ($el.hasClass('acf-row')) {
    let repeaterRowIndex = jQuery($el).index();
    jQuery($el).addClass('acf-row-index-' + repeaterRowIndex);
  }
}

function move_ws_1_step_1_result() {
  $('.workshop-v2-one-step-1-result').prependTo('.acf-form-fields');
}


/**
 *
 */
function stepsLoader() {
  var step = $('.af-page-button.current').data('index');
  $('.workshop-form-steps-header__content').removeClass('workshop-form-steps-header__content--active');
  $('.workshop-form-steps-header__content[data-index=' + '"' + step + '"]').addClass('workshop-form-steps-header__content--active');
  if(step === 0 ) {
    $('.workshop-v2-one-step-1-result').show();
  } else {
    $('.workshop-v2-one-step-1-result').hide();
  }
  workshop_steps_counter(step);
}

/**
 *
 */
function workshop_steps_counter(step) {
  var ws_step_counter = acf.getFields({
    name: 'ws_step_counter_' + get_language(),
    limit: 1,
  });

  ws_step_counter[0].val(step);
}

/**
 *
 */
function inputHidden() {
  jQuery('.ws-id-auth').attr('hidden', true);
  jQuery('.ws-step-counter').attr('hidden', true);
  jQuery('.ws-relation').attr('hidden', true);
}

/**
 *
 */
function get_language() {
  return jQuery('html').attr('lang').toLowerCase().replace(new RegExp('-', 'g'), '_');
}

/**
 *
 */
function get_field_Key(name) {
  var field = acf.getFields({
    name: name,
    limit: 1,
  });


  if(field.length >= 1) {
    return field[0].data['key'];
  }

}

/**
 *
 */
function get_field_key_repeater(name, column) {
  return jQuery('div[data-name="' + name + '"').find('td[data-name="' + column + '"]').data('key'); //field_637e34151c8
}



function repeaterLinker() {
  var language = get_language()
  var step_1_field_1 = get_field_Key('ws_v2_two_step_1_field_1_' + language);
  var step_2_field_1 = get_field_Key('ws_v2_two_step_2_field_1_' + language);
  var step_5_field_1 = get_field_Key('ws_v2_two_step_5_field_1_' + language);

  var step_1_field_1_column_4 = get_field_key_repeater('ws_v2_two_step_1_field_1_' + language, 'column_4');
  var step_2_field_1_column_1 = get_field_key_repeater('ws_v2_two_step_2_field_1_' + language, 'column_1');
  var step_2_field_1_column_4 = get_field_key_repeater('ws_v2_two_step_2_field_1_' + language, 'column_4');
  var step_5_field_1_column_1 = get_field_key_repeater('ws_v2_two_step_5_field_1_' + language, 'column_1');


  /**
   *
   */
  new acfRepeaterModel({
    masterKey: step_2_field_1,
    cloneKey: step_5_field_1,
    onlyRepeater: true,
  });

  new acfRepeaterModel({
    masterKey: step_5_field_1,
    cloneKey: step_1_field_1,
    onlyRepeater: true,
  });

  new acfRepeaterModel({
    masterKey: step_2_field_1,
    cloneKey: step_5_field_1,
    targetCloneField: step_2_field_1_column_4,
    targetPasteField: step_5_field_1_column_1,
    onlyData: true,
  });

  new acfRepeaterModel({
    masterKey: step_5_field_1,
    cloneKey: step_2_field_1,
    targetCloneField: step_5_field_1_column_1,
    targetPasteField: step_2_field_1_column_4,
    onlyData: true,
  });


  /**
   *
   */
  new acfRepeaterModel({
    masterKey: step_1_field_1,
    cloneKey: step_2_field_1,
    onlyRepeater: true,
  });

 new acfRepeaterModel({
    masterKey: step_1_field_1,
    cloneKey: step_2_field_1,
    targetCloneField: step_1_field_1_column_4,
    targetPasteField: step_2_field_1_column_1,
    onlyData: true,
  });

  new acfRepeaterModel({
    masterKey: step_2_field_1,
    cloneKey: step_1_field_1,
    targetCloneField: step_2_field_1_column_1,
    targetPasteField: step_1_field_1_column_4,
    onlyData: true,
  });
}


/**
 *
 */
var acfRepeaterModel = acf.Model.extend({

  wait: 'ready',

  data: {
    'masterKey': '',
    'cloneKey': '',
    'targetCloneField': '',
    'targetPasteField': '',
    'onlyRepeater': '',
    'onlyData': '',
  },

  actions: {
    'duplicate': 'onAppend',
    'remove': 'onRemove',
  },

  events: {
    'keyup .acf-input textarea': 'onKeyUp',
  },

  setup: function (props) {
    // store data
    $.extend(this.data, props);
  },

  onKeyUp: function (e, $el) {
    if (!this.get('onlyRepeater')) {

      // get repeater from the text input
      var repeater = this.getRepeater($el);

      if (!repeater) {
        return;
      }

      var field = acf.getClosestField($el);

      if (!field) {
        return;
      }

      var index = field.$el.closest('.acf-row').index();

      var targetfield = acf.getFields({
        type: 'textarea',
        key: this.get('targetCloneField'),
        parent: repeater.$row(index),
      }).shift();

      // get related repeater
      var relatedRepeater = this.getRelatedRepeater(repeater);

      if (!relatedRepeater) {
        return;
      }

      // find text sub field on the same row with specific key
      var textField = acf.getFields({
        type: 'textarea',
        key: this.get('targetPasteField'),
        parent: relatedRepeater.$row(index),
      }).shift();

      // if sub field with the key is found
      if (textField) {
        // set value
        textField.val(targetfield.val());
      }
    }
  },

  onAppend: function ($el, $el2) {

    if (!this.get('onlyData')) {
      // validate repeater row
      if (!$el2.is('.acf-row')) {
        return;
      }

      // get repeater field from row
      var repeater = this.getRepeater($el2);

      // bail early
      if (!repeater) {
        return;
      }

      // row duplicated
      if (this.isDuplicate($el)) {

        this.executeAction(repeater, 'duplicateRow', $el);

        // row added normally
      } else {

        this.executeAction(repeater, 'add', $el2);

      }
    }

  },

  onRemove: function ($el) {

    // validate repeater row
    if (!$el.is('.acf-row')) {
      return;
    }

    // get repeater field
    var repeater = this.getRepeater($el);

    if (!repeater) {
      return;
    }

    // delete the row
    this.executeAction(repeater, 'remove', $el);

  },

  executeAction: function (repeater, action, $el) {

    // default args
    var args = null;
    var index = $el.index();

    // find the related repeater
    var relatedRepeater = this.getRelatedRepeater(repeater);

    if (!relatedRepeater) {
      return;
    }

    // get index of newly created row
    if (action === 'add') {

      // $el is $el2 at this point
      args = {
        before: relatedRepeater.$row(index),
      };

      // get index for duplicate/remove
    } else if (action === 'duplicateRow' || action === 'remove') {

      args = relatedRepeater.$row(index);

    }

    // set related repeater as busy & execute action
    // avoid inifite loop
    relatedRepeater.busy = true;
    relatedRepeater[action](args);
    relatedRepeater.busy = false;

  },

  getRepeater: function ($el) {

    // get repeater
    var $field = $el.closest('[data-type="repeater"]');
    var repeater = acf.getInstance($field);

    if (!repeater) {
      return false;
    }

    // bail early if field is busy
    // avoid infinite loop
    if (repeater.busy) {
      return false;
    }

    // return
    return repeater;

  },

  getRelatedRepeater: function (repeater) {

    var relatedRepeater = null;

    if (repeater.get('key') === this.get('masterKey')) {

      relatedRepeater = acf.getField(this.get('cloneKey'));

    } else if (repeater.get('key') === this.get('cloneKey')) {

      relatedRepeater = acf.getField(this.get('masterKey'));

    }

    return relatedRepeater;

  },

  isDuplicate: function ($el) {
    return !$el.is('.acf-clone');
  },
});
